import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Link } from 'react-router-dom';
import Stepper from './stepper';
import Company from './company';
import Character from './character';
import Objectives from './objectives';
import officeIcon from '../../../../globals/images/intro1.png';
import personIcon from '../../../../globals/images/intro2.png';
import objectivesIcon from '../../../../globals/images/intro3.png';
import styles from './about.module.scss';

class About extends Component {

    constructor(props) {
        super(props);
        let stepperArray = this.getStepperArray(props);

        this.state = {
            stepperArray: this.setLinkVisitedFlag(stepperArray, props)
        };
    }

    componentWillReceiveProps(nextProps) {
        let newArray = this.setLinkVisitedFlag(this.state.stepperArray, nextProps);
        this.setState({
            stepperArray: newArray
        })
    }

    getStepperArray = (props) => {
        let img1 = props.introductionData.introPage.step1Image ? props.introductionData.introPage.step1Image : officeIcon
        let img2 = props.introductionData.introPage.step2Image ? props.introductionData.introPage.step2Image : personIcon
        let img3 = props.introductionData.introPage.step3Image ? props.introductionData.introPage.step3Image : objectivesIcon
        let title1 = props.introductionData.introPage.step1Header ? props.introductionData.introPage.step1Header : 'About Company'
        let title2 = props.introductionData.introPage.step2Header ? props.introductionData.introPage.step2Header : 'About Character'
        let title3 = props.introductionData.introPage.step3Header ? props.introductionData.introPage.step3Header : 'Objectives'

        return [
            {
                id: 0,
                url: '/intro/company',
                imageUrl: img1,
                text: title1,
                isLinkVisited: false,
                isFirstItem: true
            },
            {
                id: 1,
                url: '/intro/character',
                imageUrl: img2,
                text: title2,
                isLinkVisited: false
            },
            {
                id: 2,
                url: '/intro/objectives',
                imageUrl: img3,
                text: title3,
                isLinkVisited: false
            }
        ];
    }

    setLinkVisitedFlag = (stepperArray, currentProps) => {
        let { currentPageId } = currentProps;
        return stepperArray.map(item => {
            if (item.id <= currentPageId && !item.isLinkVisited) {
                return {
                    ...item,
                    isLinkVisited: true
                }
            } else {
                return item
            }
        })
    }

    company = (props) => {
        return <Company {...props} introductionData={this.props.introductionData} />
    }

    character = (props) => {
        return <Character
            {...props}
            orgChart={this.props.orgChart}
            actors={this.props.actors}
            selfActor={this.props.selfActor}
            introductionData={this.props.introductionData}
        />
    }

    objectives = (props) => {
        return <Objectives {...props} nextUrl={this.props.nextUrl} introductionData={this.props.introductionData} />
    }

    render() {
        let { stepperArray, nextUrl } = this.state;
        let { currentPageId } = this.props;

        return (
            <div className={styles['intro-page-wrapper']}>
                <Stepper
                    stepperArray={stepperArray}
                    nextUrl={nextUrl}
                    currentPageId={currentPageId}
                    introductionData={this.props.introductionData}
                />

                <div className={styles['about-pages-container']}>
                    <Route path={'/intro/company'} component={this.company} />
                    <Route path={'/intro/character'} component={this.character} />
                    <Route path={'/intro/objectives'} component={this.objectives} />
                </div>
            </div>
        )
    }
}

About.propTypes = {
    timeData: PropTypes.object
};

About.defaultProps = {
    timeData: {}
}

export default About;


// WEBPACK FOOTER //
// /src/components/intro/pages/about/About.js